import { Component, OnInit, AfterViewInit, OnChanges, ViewChild, } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { GeneralService, UserService } from '../../../../services/_index';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { DealsWizardModel, DealSignatureModel } from '../../../../_models/_index';
import { DealStatusEnum, AlertDialogConfirmTypeEnum } from '../../../../_enums/_index';

@Component({
    selector: 'app-signature-dialog',
    templateUrl: './signature-dialog.component.html',
    styleUrls: ['./signature-dialog.component.css']
})
export class SignatureDialogComponent implements OnInit, AfterViewInit {
    isReadOnly: boolean;
    dialogHeader: string;
    fileToUpload: File;
    url: any;
    dealsWizard: DealsWizardModel;
    dealSignature: DealSignatureModel;

    @ViewChild(SignaturePad) signaturePad: SignaturePad;

    signaturePadOptions: Object = {
        'minWidth': 1,
        'canvasWidth': 200,
        'canvasHeight': 200
    };

    ngAfterViewInit() {
        if (this.signaturePad) {
            this.signaturePad.set('minWidth', 1);
            this.signaturePad.clear();

            if (this.dealsWizard.signature) {
                this.signaturePad.fromDataURL(this.dealsWizard.signature, { width: 200, height: 200 });
            }
            this.readFile();
        }
    }

    constructor(private dialog: MatDialog,
        private generalService: GeneralService,
        private userService: UserService,
        public dialogRef: MatDialogRef<SignatureDialogComponent>) {
        this.dealSignature = new DealSignatureModel();
        this.isReadOnly = this.userService.isRepresentative();
    }

    ngOnInit() {        
        if (this.dealsWizard.companySignature != null)
            this.url = "data:"+this.dealsWizard.companySignatureType +";base64," + this.dealsWizard.companySignature;
        this.fileToUpload = this.dealsWizard.fileToUpload;
    }

    save() {
        let canSave = true;
        switch (this.dealsWizard.statusID) {
            case DealStatusEnum.Opened:
            case DealStatusEnum.Sent:
                if (this.userService.isCustomer()) {
                    if (this.signaturePad.isEmpty()) {
                        this.generalService.showErrorDialog("חובה לחתום על ההזמנה");
                        canSave = false;
                    }
                    else if(this.url==null)
                    {
                        canSave = false;
                        this.generalService.showConfirmDialog('האם אתה חברה בע"מ?', AlertDialogConfirmTypeEnum.YesNo).then(result => {
                            if (result) {
                                    this.generalService.showErrorDialog("צרף חותמת חברה!");
                                    canSave = false
                            }
                            else
                            {
                                this.closeDialog();
                            }
                        });
                    }
                }
                break;
        }
        if (canSave) {
            this.closeDialog();
        }
    }

    closeDialog()
    {
        this.dealSignature.isEmpty = this.signaturePad.isEmpty();
        this.dealSignature.signature = this.signaturePad.toDataURL();
        this.dealSignature.fileToUpload = this.fileToUpload;
        this.dialogRef.close(this.dealSignature);
    }


    clearSign() {
        this.signaturePad.clear();
    }


    onFileInput(fileInput: any) {
        this.fileToUpload = (<Array<File>>fileInput.target.files)[0];
        this.readFile();
    }

    readFile() {
        if (this.fileToUpload == null) return;

        var reader = new FileReader();
        reader.readAsDataURL(this.fileToUpload); // read file as data url        
        reader.onload = (event: any) => { // called once readAsDataURL is completed            
            this.url = event.target.result;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-approval/signature-dialog/signature-dialog.component.ts